import LocalizedClientLink from "@modules/common/components/localized-client-link"
import SkeletonShopButton from "@modules/skeletons/components/skeleton-shop-button"

interface HeadProps {
  invertLogo?: boolean
}

export default function Head({ invertLogo = false }: HeadProps) {
  return (
    <div id={"nav-header"}>
      <header className="flex w-full content-container relative small:mx-auto justify-between p-4">
        <div className="small:mx-auto flex justify-between items-center min-w-full">
          <div className="flex items-center small:space-x-4">
            <LocalizedClientLink
              className="hover:text-ui-fg-base flex items-center w-fit"
              href="/"
            >
              <img src="/logo.png" alt="Logo" className={`inline mr-2 h-12 ${invertLogo ? 'invert' : ''}`}/>
            </LocalizedClientLink>
          </div>
        </div>
      </header>
    </div>
  )
}
